import { detectFixMessageSeparator } from "./parser-sep-detector";

export const splitByFixMessage = (line: string): string[] => {
  if (!line || typeof line !== "string") {
    return [];
  }

  const messages: string[] = [];
  let currentIndex = 0;
  const separator = detectFixMessageSeparator(line);
  if (separator === null) {
    return [];
  }

  while (currentIndex < line.length) {
    // Find the next "8=FIX" that could be the start of a message
    const fixStartIndex = line.indexOf("8=FIX", currentIndex);
    if (fixStartIndex === -1) {
      break; // No more messages
    }

    // Check if this is actually the start of a message (not within a field value)
    // A valid message start should either be at the beginning or preceded by separator
    const isValidStart =
      fixStartIndex === 0 || line[fixStartIndex - 1] === separator;

    if (!isValidStart) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    // Find the BeginString field end
    const beginStringEnd = line.indexOf(separator, fixStartIndex);
    if (beginStringEnd === -1) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    // Find the BodyLength field (should be next field after BeginString)
    const bodyLengthStart = beginStringEnd + 1;
    const bodyLengthEnd = line.indexOf(separator, bodyLengthStart);
    if (bodyLengthEnd === -1) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    const bodyLengthField = line.substring(bodyLengthStart, bodyLengthEnd);
    if (!bodyLengthField.startsWith("9=")) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    // Extract the BodyLength value
    const bodyLengthStr = bodyLengthField.substring(2); // Remove "9="
    const bodyLength = parseInt(bodyLengthStr, 10);

    if (isNaN(bodyLength) || bodyLength < 0) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    // Calculate message boundaries
    // Body starts after BodyLength field (including its separator)
    const bodyStart = bodyLengthEnd + 1;
    const bodyEnd = bodyStart + bodyLength;

    // Validate we have enough data
    if (bodyEnd > line.length) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    // Find the CheckSum field which should start at bodyEnd
    const checksumEnd = line.indexOf(separator, bodyEnd);
    if (checksumEnd === -1) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    const checksumField = line.substring(bodyEnd, checksumEnd);
    if (!checksumField.startsWith("10=")) {
      currentIndex = fixStartIndex + 1;
      continue;
    }

    // Extract the complete message
    const messageEnd = checksumEnd + 1; // Include separator after CheckSum
    const message = line.substring(fixStartIndex, messageEnd);

    messages.push(message);
    currentIndex = messageEnd;
  }

  return messages;
};
